import classNames from 'classnames';
import styles from './InfoBusinessCardWrapper.module.scss';
import { WithClassName } from '../../types';

export function InfoBusinessCardWrapper({
  children,
  withSeparator,
}: {
  children: React.ReactNode;
  withSeparator?: boolean;
}) {
  return (
    <div
      className={classNames({
        [styles.cardBody]: true,
        [styles.cardWithSeparator]: withSeparator,
      })}
    >
      {children}
    </div>
  );
}
